import { AOSRType, FilestoreAPI } from '@builddocs/filestore-api'
import { Notification } from '@builddocs/mui'
import { Flex } from 'antd'
import { format, parseISO } from 'date-fns'
import { ru } from 'date-fns/locale'
import { useQuery } from 'react-query'

interface AosrBadCertificateNoticeProps {
  act: AOSRType
}

export function AosrBadCertificateNotice({
  act,
}: AosrBadCertificateNoticeProps) {
  const { data } = useQuery({
    queryFn: () =>
      FilestoreAPI.get<{
        expiringCertificates: Array<{
          id: string
          name: string
          number: string
          issueDate: string
        }>
        expiredCertificates: Array<{
          id: string
          name: string
          number: string
          issueDate: string
        }>
      }>(`/act-aosr/${act.id}/expiring-certificates`).then(r => r.data),
    queryKey: ['aosr', act.id, 'expiring-certificates'],
  })

  return (
    <Flex
      vertical
      gap="8px"
      style={{
        marginBottom: '8px',
      }}
    >
      {!!data?.expiringCertificates?.length && (
        <Notification
          message="К акту/работе прикреплены истекающие во время проведения работ сертификаты:"
          type="warning"
        >
          {data?.expiringCertificates
            .map(cert =>
              [
                cert.name,
                cert.number,
                cert.issueDate &&
                  format(parseISO(cert.issueDate), 'PP', {
                    locale: ru,
                  }),
              ].join(' '),
            )
            .join('; ')}
        </Notification>
      )}
      {!!data?.expiredCertificates?.length && (
        <Notification
          message="К акту/работе прикреплены истёкшие на момент начала проведения работ сертификаты:"
          type="error"
        >
          {data?.expiredCertificates
            .map(cert =>
              [
                cert.name,
                cert.number,
                cert.issueDate &&
                  format(parseISO(cert.issueDate), 'PP', {
                    locale: ru,
                  }),
              ].join(' '),
            )
            .join('; ')}
        </Notification>
      )}
    </Flex>
  )
}
